import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
type ContactCalloutProps = {
  title?: string;
  description?: string;
};
export function ContactCallout({
  title = 'Ready for a CRM that supports the way you work?',
  description = 'Tell me what is getting in the way. I will help you identify a practical next step.'
}: ContactCalloutProps) {
  return <section className="bg-[#e1eee8] px-5 py-16 sm:px-8 sm:py-20 lg:px-10" aria-labelledby="contact-heading" data-id="element-17" data-mp="xqg43p3fqsr8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 md:flex-row md:items-end md:justify-between" data-id="element-18" data-mp="ss4unfh1yk9j">
        <div className="max-w-2xl" data-id="element-19" data-mp="onx6bjeib6bu">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#286151]" data-id="element-20" data-mp="or2tuu7hm05g">
            A useful first conversation
          </p>
          <h2 id="contact-heading" className="mt-4 text-3xl font-semibold tracking-tight text-[#172820] sm:text-4xl" style={{
          fontFamily: 'var(--font-display)'
        }} data-id="element-21" data-mp="39fqrsm4hu58i">
            {title}
          </h2>
          <p className="mt-4 max-w-xl text-base leading-7 text-[#3e564b]" data-id="element-22" data-mp="1bnaqp6jqz30y">
            {description}
          </p>
        </div>
        <Link to="/contact" className="group inline-flex shrink-0 items-center justify-center gap-2 rounded-sm bg-[#172820] px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#286151] focus:outline-none focus:ring-2 focus:ring-[#286151] focus:ring-offset-2" data-id="element-23" data-mp="xmq6q723j15v">
          Share project details{' '}
          <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-24" data-mp="sqjaj5zi5414" />
        </Link>
      </div>
    </section>;
}